/* eslint-disable no-console */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import repository from './axios/repository'
import './assets/css/bootstrap.min.css';
import './assets/css/main.css'
import cookies from 'vue-cookies'
import VCalendar from 'v-calendar'
import CommonMethod from '@/app/components/common/CommonMethod.vue'

Vue.mixin(CommonMethod);

//HACK: repositoryにcookiesとstoreを渡すようにしてrepository.jsで定義する
repository.interceptors.request.use(config => {
  // 管理者向けAPI認証トークン設定
  const managerToken = cookies.get('api-token')
  if (managerToken) {
    config.headers['Authorization'] = `Bearer ${ managerToken }`
  }

  // ユーザー向けAPI認証トークン設定
  const userToken = cookies.get('user-api-token')
  const storeId = store.getters['store/id']
  // 店舗情報とトークンがあるときはセット
  if (userToken && storeId) {
    config.headers['X-HACCP-TOKEN'] = userToken
  }

  // 操作者ユーザー設定（ログイン時、または名前選択時にVuexにセットされる）
  let userType = store.getters['user/type']
  let userInfo = store.getters['user/info']
  config.headers['X-HACCP-' + userType] = userInfo

  // 操作中ブランドの設定
  config.headers['X-HACCP-URL'] = store.getters['brand/url']
  
  return config
})

Vue.config.productionTip = false
Vue.prototype.$axios = repository
Vue.prototype.$apiEndpoint = process.env.VUE_APP_API_URL
Vue.use(cookies)
Vue.use(VCalendar)

// エラー検知
Vue.config.errorHandler = (err, vm, info) => {
  console.log(`Captured in Vue.config.errorHandler: ${info}`, err)
}
window.addEventListener("error", event => {
  console.log("Captured in error EventListener", event.error)
})
window.addEventListener("unhandledrejection", event => {
  console.log("Captured in unhandledrejection EventListener", event.reason)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
